/* Direct Team Sports - personalization fields.
   Reveals + requires the Name/Number line-item property inputs only when the
   customer selects the paid personalization option ("Yes Please"). The box is
   marked with [data-dts-perso-box] and data-dts-perso-optindex (1-based option
   position, matching the theme's data-index="optionN"). */
(function () {
  function initBox(box) {
    if (box.__dtsInit) { return; }
    box.__dtsInit = true;
    var form = box.closest('form');
    if (!form) { return; }
    var optIndex = box.getAttribute('data-dts-perso-optindex');
    var inputs = box.querySelectorAll('[data-dts-perso-input]');
    var msg = box.querySelector('[data-dts-perso-msg]');
    var atc = form.querySelector('button[name="add"]');

    function selectedValue() {
      var di = 'option' + optIndex;
      var radios = form.querySelectorAll('input[type="radio"][data-index="' + di + '"]');
      if (radios.length) {
        for (var i = 0; i < radios.length; i++) { if (radios[i].checked) { return radios[i].value; } }
        return null;
      }
      var sel = form.querySelector('select[data-index="' + di + '"]');
      return sel ? sel.value : null;
    }
    function isYes(v) { return v != null && v.toLowerCase().indexOf('no thanks') === -1; }

    function update() {
      var show = isYes(selectedValue());
      box.style.display = show ? '' : 'none';
      for (var i = 0; i < inputs.length; i++) {
        if (show) { inputs[i].disabled = false; inputs[i].setAttribute('required', 'required'); }
        else { inputs[i].removeAttribute('required'); inputs[i].disabled = true; }
      }
      if (!show && msg) { msg.style.display = 'none'; }
    }
    function firstEmpty() {
      for (var i = 0; i < inputs.length; i++) {
        if (!inputs[i].disabled && !inputs[i].value.trim()) { return inputs[i]; }
      }
      return null;
    }
    function guard(e) {
      if (box.style.display === 'none') { return; }
      var miss = firstEmpty();
      if (miss) {
        e.preventDefault();
        e.stopImmediatePropagation();
        if (msg) { msg.textContent = 'Please fill in your personalization details before adding to cart.'; msg.style.display = 'block'; }
        miss.focus();
      }
    }

    form.addEventListener('change', function (e) {
      if (e.target && (e.target.matches('input[type="radio"][data-index]') || e.target.matches('select[data-index]'))) { update(); }
    });
    form.addEventListener('submit', guard, true);
    if (atc) { atc.addEventListener('click', guard, true); }
    update();
  }

  function initAll() {
    var boxes = document.querySelectorAll('[data-dts-perso-box]');
    for (var i = 0; i < boxes.length; i++) { initBox(boxes[i]); }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  // Re-init for AJAX-injected forms (e.g. quick view). Debounced.
  var t;
  var mo = new MutationObserver(function () { clearTimeout(t); t = setTimeout(initAll, 200); });
  mo.observe(document.documentElement, { childList: true, subtree: true });
})();
